import { styled } from "@mui/material";

export const SelectVideoModalStyled = styled("div")(
    ({ theme }) => `
    display: flex;
`
);

export const SelectVideoModalListWrapperStyled = styled("div")(
    ({ theme }) => `
    width: 600px;
    flex: 0 0 600px;
`
);

export const SelectVideoModalListHeaderStyled = styled("div")(
    ({ theme }) => `
margin-bottom: ${theme.spacing(2)};
`
);
export const SelectVideoModalListBodyStyled = styled("div")(
    ({ theme }) => `
    height: 400px;
    overflow: auto;
    margin-bottom: ${theme.spacing(2)};
`
);
export const SelectVideoModalListBodyLoadingStyled = styled("div")(
    ({ theme }) => `
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${theme.spacing(2)};
`
);
export const SelectVideoModalListFooterStyled = styled("div")(
    ({ theme }) => `

`
);

export const SelectVideoModalPreviewStyled = styled("div")(
    ({ theme }) => `
    width: 450px;
    flex: 0 0 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    video {
        width: 100%;
        height: 400px;
        border-radius: ${theme.spacing(1)};
    }
`
);

export const SelectVideoModalFooterStyled = styled("div")(
    ({ theme }) => `
    display: flex;
    align-items: center;
`
);
export const SelectVideoModalFooterPaginationStyled = styled("div")(
    ({ theme }) => `
    
`
);
export const SelectVideoModalFooterButtonsStyled = styled("div")(
    ({ theme }) => `
    margin-left: auto;
`
);

export const SelectVideoModalItemStyled = styled("div")<{ active: boolean }>(
    ({ theme, active }) => `
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${theme.palette.mode === "dark" ? "#666" : "#ccc"};
    padding: ${theme.spacing(1)};
    background-color: ${active ? (theme.palette.mode === "dark" ? "#323232" : "#f5f5f5") : "transparent"};
    &:hover {
        background-color: ${theme.palette.mode === "dark" ? "#323232" : "#f5f5f5"};
    }
`
);

export const SelectVideoModalItemHeaderStyled = styled("div")(
    ({ theme }) => `
    width: 50px;
    height: 70px;
    flex: 0 0 50px;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: ${theme.spacing(1)};
    }
`
);

export const SelectVideoModalItemContentStyled = styled("div")(
    ({ theme }) => `
    flex: 0 0 calc(100% - 50px);
    padding-left: ${theme.spacing(2)};
    p {
        line-height: 22px;
        font-weight: 600;
        margin: 0;
    }
    span {
        margin-top: ${theme.spacing(1)};
        font-size: 12px;
    }
`
);
